import { useDispatch, useSelector } from 'react-redux';
import {
  login as loginThunk,
  logout as logoutThunk,
  registerUser,
  selectAuthLoading,
  selectAuthToken,
  selectAuthUser,
  selectIsAuthenticated,
} from '../store/authSlice.js';

export const useAuth = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectAuthUser);
  const token = useSelector(selectAuthToken);
  const loading = useSelector(selectAuthLoading);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const login = (identifier, password) =>
    dispatch(loginThunk({ identifier, password })).unwrap();

  const register = (userData) => dispatch(registerUser(userData)).unwrap();

  const logout = () => dispatch(logoutThunk());

  return {
    user,
    token,
    isAuthenticated,
    loading,
    login,
    register,
    logout,
  };
};
